import type { AdAccountsResponse, AudienceDestination } from '../types';

/* The service does not set adAccountName at create, so fall back to the ad account lists */
export const adAccountName = (
  destination: Pick<AudienceDestination, 'adAccountId' | 'adAccountName'>,
  adAccounts: AdAccountsResponse | null
): string => {
  if (destination.adAccountName) return destination.adAccountName;
  const match = [
    ...(adAccounts?.metaAdAccountsList ?? []),
    ...(adAccounts?.proximaAdAccountsList ?? []),
    ...(adAccounts?.tiktokAdAccountsList ?? [])
  ].find(account => account.adAccountId === destination.adAccountId);
  return match?.name ?? destination.adAccountId;
};

/* "Seed", "LAL 10% · US", or "LAL 10%" for a lookalike without a country */
export const destinationKindLabel = (
  destination: Pick<AudienceDestination, 'kind' | 'lookalikeRatio' | 'lookalikeCountry'>
): string => {
  if (destination.kind !== 'lookalike') return 'Seed';
  const ratio = `LAL ${destination.lookalikeRatio ?? '?'}%`;
  return destination.lookalikeCountry ? `${ratio} · ${destination.lookalikeCountry}` : ratio;
};
